import user from './user-reducer';
import translations from './translations-reducer';
import routing from './routing-reducer';
import modals from './modals-reducer';
import otp from './otp-reducer';
import impersonateUser from './impersonate-user-reducer';
import menuItems from './menu-items-reducer';
import esignCredits from './esign-credits-reducer';
import featureConfig from './feature-config-reducer';
import agent from './agent-reducer';
import workflowBuilderConfig from './workflow-builder-config-reducer';

export default {
  user,
  translations,
  routing,
  modals,
  otp,
  impersonateUser,
  menuItems,
  esignCredits,
  featureConfig,
  agent,
  workflowBuilderConfig,
};
